import React from 'react';
import { useTranslation } from "react-i18next";
interface SpinnCircleProps {
  spinning: boolean;
  result: number;
  handleSpinClick: () => void;
}

function SpinnCircle({ spinning, handleSpinClick, result }:SpinnCircleProps) {
  const { t } = useTranslation();
  return (
    <>
     {/* Wheel geometry (.container + segment classes) is unchanged; only the chrome around it is styled. */}
     <div className='relative mx-auto w-fit pt-7'>
      <button id='spin' className='absolute left-1/2 top-[calc(50%_+_14px)] z-10 inline-flex items-center justify-center w-[3rem] h-[3rem] md:w-[3.75rem] md:h-[3.75rem] lg:w-[3.75rem] lg:h-[3.75rem] rounded-full border-4 border-solid border-surface bg-ink text-ink-inverse text-xs md:text-sm font-bold uppercase tracking-[0.08em] shadow-md transform -translate-x-1/2 -translate-y-1/2 cursor-pointer transition-transform hover:scale-105 disabled:cursor-not-allowed disabled:hover:scale-100' onClick={handleSpinClick} disabled={spinning || result !== null } >{t("spin.modal.Wheel1")}</button>
      <span className='arrow absolute top-0 left-1/2 z-10 text-3xl font-extrabold leading-none transform -translate-x-1/2 text-ink'></span>
      <div className='container lg:w-[18.75rem] lg:h-[18.75rem] md:w-[18.75rem] md:h-[18.75rem] w-[14.75rem] h-[14.75rem] rounded-full border-[0.70rem] border-solid border-ink/90 shadow-md relative overflow-hidden'>
   
        <div className='one spinn_Cirlce'>
          <span className='text-center h-1/2 '>
            
          55
          </span>
          </div>

        <div className='two spinn_Cirlce'>
          <span className='text-center h-1/2 '>
            
          350
          </span>
          </div>

        <div className='three spinn_Cirlce'>
          <span className='text-center h-1/2 '>
            
          75
          </span>
          </div>

        <div className='four spinn_Cirlce'>
          <span className='text-center h-1/2 '>
            
          125
          </span>
          </div>

        <div className='five spinn_Cirlce'>
          <span className='text-center h-1/2 '>
            
          200
          </span>
          </div>

        <div className='six spinn_Cirlce'>
          <span className='text-center h-1/2 '>
            
          1000
          </span>
          </div>

        <div className='seven spinn_Cirlce'>
          <span className='text-center h-1/2 '>
            
          150
          </span>
          </div>

        <div className='eight spinn_Cirlce'>
          <span className='text-center h-1/2 '>
            
          500
          </span>
          </div>


      </div>
    </div>
    </>
  );
}

export default SpinnCircle;
